// This React component, `GolfBidderPage`, is a Next.js client component designed to render the GolfBidder
// landing page. It extracts data from the `dataSource` within the `data` prop and passes it to the `GolfBidder`
// component for display. The use of `TasticProps<any>` provides flexibility but could be refined with a
// specific type for better type safety. This structure ensures efficient handling of dynamic content within
// the landing page.

'use client';

import React from 'react';
import { TasticProps } from '../types';
import GolfBidder from 'components/commercetools-ui/organisms/landing-pages/golfbidder';
import { GolfBidderPageType } from 'types/next';

const GolfBidderPage = ({ data }: TasticProps<GolfBidderPageType>) => {
  const GolfBidderData = data?.data?.dataSource;

  return (
    <>
      <GolfBidder golfBidder={GolfBidderData} />
    </>
  );
};

export default GolfBidderPage;
